import { apiGet } from '@/api/http';

import type { EmploymentType } from '@/types/employmentType';

const api_url = import.meta.env.VITE_API_URL;

export const getEmploymentTypeList = () =>
  apiGet<EmploymentType[]>(`${api_url}employment-types/`);
